import { IAttribute, IAttributeTemplate } from '@alberta/konexi-shared';
import { ignore } from 'src/app/common/tracking/tracker';

export class AttributeViewModel implements IAttribute {
  public attributeTemplate: IAttributeTemplate;
  public value: any;
  @ignore() public new: boolean;
  @ignore() public notFoundInProductGroup: boolean;
}
